<template>
  <div class="f-bullet-number" :class="type">
    {{ number }}
  </div>
</template>
<script>
export default {
  props: ["number", "type"],
};
</script>
<style lang="scss">
.f-bullet-number {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 4px 8px;

  border-radius: 16px;

  background-color: var(--turquoise);
  color: var(--white);

  &.overlay {
    background-color: var(--white);
    color: var(--black);
  }
}
.dark-mode {
  .f-bullet-number {
    background-color: var(--navigation);
    color: var(--white-a75);

    &.overlay {
      background-color: var(--white-a10);
      color: var(--white-a50);
    }
  }
}
</style>